function defineSaPdpBenefits() {
  if (customElements.get('sa-pdp-benefits')) return true;
  if (typeof PopupBase === 'undefined') return false;

  class SaPdpBenefits extends PopupBase {
    constructor() {
      super();
      this.activeTrigger = null;
      this.templates = new Map();
      this.popupTriggers = [];
      this.triggers = [];
      this.handleTriggerClick = this.handleTriggerClick.bind(this);
    }

    connectedCallback() {
      queueMicrotask(() => {
        if (this.isConnected) this.initialize();
      });
    }

    initialize() {
      if (this.initialized) return;

      this.customClass = this.dataset.customClass || 'sa-pdp-benefits-modal';
      this.templates = new Map(
        Array.from(this.querySelectorAll('[data-sa-pdp-benefits-template]')).map((template) => [
          template.dataset.saPdpBenefitsTemplate,
          template,
        ])
      );
      this.popupTriggers = Array.from(this.querySelectorAll('[data-sa-pdp-benefits-trigger]'));
      this.triggers = this.popupTriggers;

      if (!this.triggers.length) return;

      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', this.handleTriggerClick);
      });
      this.initialized = true;
    }

    disconnectedCallback() {
      this.triggers.forEach((trigger) => {
        trigger.removeEventListener('click', this.handleTriggerClick);
      });

      const modal = this.modal;
      this.modal = null;
      if (typeof modal?.close === 'function') modal.close();

      this.activeTrigger = null;
      this.templates.clear();
      this.popupTriggers = [];
      this.triggers = [];
      this.initialized = false;
    }

    handleTriggerClick(event) {
      event.preventDefault();
      const trigger = event.currentTarget;
      const popupKey = trigger.dataset.popupKey;
      const template = this.templates.get(popupKey);
      if (!template || this.modal) return;

      this.activeTrigger = trigger;
      this.setTriggerState(true);

      const content = document.createElement('div');
      content.appendChild(template.content.cloneNode(true));

      this.initPopup(content, null, 'sa-pdp-benefits-modal', (modalBox) => {
        this.configureDialog(modalBox);
      });
    }

    configureDialog(modalBox) {
      const dialog = modalBox.querySelector('[data-sa-pdp-benefits-dialog]');
      const title = modalBox.querySelector('[data-sa-pdp-benefits-title]');
      const modalRoot = modalBox.closest('.tingle-modal');
      const closeButton = modalRoot?.querySelector('.tingle-modal__close');
      const closeIcon = closeButton?.querySelector('.tingle-modal__closeIcon');
      const closeIconTemplate = this.querySelector('[data-sa-pdp-benefits-close-icon]');
      const popupLabel = dialog?.dataset.popupLabel;
      const closeLabel = dialog?.dataset.closeLabel;
      const colorScheme = this.dataset.colorScheme;

      if (colorScheme) {
        modalBox.classList.add('gradient', `color-${colorScheme}`, 'use-color-scheme');
      }

      if (dialog?.id) {
        modalBox.id = dialog.id;
        dialog.removeAttribute('id');
      }

      modalBox.setAttribute('role', 'dialog');
      modalBox.setAttribute('aria-modal', 'true');

      if (title?.id) {
        modalBox.setAttribute('aria-labelledby', title.id);
      } else if (popupLabel) {
        modalBox.setAttribute('aria-label', popupLabel);
      } else {
        const triggerLabel = this.activeTrigger?.innerText.trim();
        if (triggerLabel) modalBox.setAttribute('aria-label', triggerLabel);
      }

      if (modalBox.id && this.activeTrigger) {
        this.activeTrigger.setAttribute('aria-controls', modalBox.id);
      }

      if (closeButton) {
        modalBox.prepend(closeButton);
        if (closeLabel) {
          closeButton.setAttribute('aria-label', closeLabel);
        }

        if (closeIcon && closeIconTemplate) {
          closeIcon.replaceChildren(closeIconTemplate.content.cloneNode(true));
        }
      }

      if (this._focusTrapCleanup) this._focusTrapCleanup();
      this._focusTrapCleanup = trapFocus(modalBox);
    }

    setTriggerState(isExpanded) {
      this.popupTriggers.forEach((trigger) => {
        trigger.setAttribute('aria-expanded', String(isExpanded && trigger === this.activeTrigger));
      });
    }

    onCloseEvent() {
      const triggerToRestore = this.activeTrigger;
      this.setTriggerState(false);
      this.activeTrigger = null;
      this.modal = null;

      if (triggerToRestore?.isConnected) {
        requestAnimationFrame(() => {
          if (!this.activeTrigger) triggerToRestore.focus({ preventScroll: true });
        });
      }
    }
  }

  customElements.define('sa-pdp-benefits', SaPdpBenefits);
  return true;
}

function initializeSaPdpBenefits() {
  if (defineSaPdpBenefits()) return;

  const handleDependencyLoad = (event) => {
    if (!(event.target instanceof HTMLScriptElement)) return;
    if (!defineSaPdpBenefits()) return;

    document.removeEventListener('load', handleDependencyLoad, true);
  };

  document.addEventListener('load', handleDependencyLoad, true);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeSaPdpBenefits, { once: true });
} else {
  initializeSaPdpBenefits();
}
